import useQueryParams from "src/core/common/hooks/useQueryParams";

const ORDER_SORT_PARAM = "sort-orders-by";
export function useOrdersSortBy(replace = false) {
  const [params, setParam] = useQueryParams([ORDER_SORT_PARAM], replace);

  function setOrder(order) {
    setParam([ORDER_SORT_PARAM], [order]);
  }
  return [params[ORDER_SORT_PARAM], setOrder];
}
